import config from "./configuration";
import ConstantsList from "../common/SupplierConstants";

// this block needed to get the login Token and Login user _id
let localData = localStorage.getItem("userData");
let userData = {};
if (localData) {
  userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getMenu";
  return callPOST(api_url, param);
}

// get info from the configuration.js file
async function getConfig() {
  return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getUserDetails";
  let param = { _id: userData.data._id };
  return callPOST(api_url, param);
}

// API Error Handling
async function handleResponseError(response) {
  throw new Error("HTTP error, status = " + response.status);
}

// API Error Handling
async function handleError(error) {
  console.log(error.message);
}

// Common GET Method
async function callGET(api_url) {
  return fetch(api_url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      if (items.responseCode !== 401) {
        // console.log(">> GET Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      console.log(">> e", error);
      handleError(error);
    });
}

// Common POST Method
async function callPOST(api_url, param) {
  // console.log(">> check URL", api_url);
  if (!param) {
    param = {};
  }
  param.timeZone = userTimezone;
  return await fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

// Common POST Method for Upload
async function callPOSTUpload(api_url, param) {
  // console.log(">>callPOSTUpload param ", param);
  return await fetch(api_url, {
    method: "POST",
    headers: {
      // 'Content-Type': 'multipart/form-data',
      Authorization: "Bearer " + userData.token,
    },
    body: param,
  })
    .then(async (response) => {
      if (!response.ok) {
        // Non-2xx (e.g. HTTP 429 rate limit on OCR uploads). Resolve with the
        // server's error body ({ status, message }) instead of swallowing it, so
        // callers can show a graceful toast instead of a silent empty result.
        try {
          const body = await response.json();
          if (body?.message) return body;
        } catch (_) {
          // Response body is not JSON (e.g. HTML error page)
        }
        return {
          status: response.status,
          message: "HTTP error, status = " + response.status,
        };
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

// Common Post ResetPassword Method
async function callPostResetPassword(api_url, param, token) {
  // console.log(">> check URL", api_url);
  if (!param) {
    param = {};
  }
  return await fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

// Common PATCH Method
async function callPATCH(api_url, param) {
  if (!param) param = {};
  param.timeZone = userTimezone;
  return await fetch(api_url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) handleResponseError(response);
      return response.json();
    })
    .then((items) => {
      if (items.responseCode !== 401) {
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

//POST - Upload files
async function uploadFiles(param) {
  let api_url = config.BASE_URL + "api/uploadFiles";
  return callPOSTUpload(api_url, param);
}
//POST - getUploadedFiles files
async function getUploadedFiles(param) {
  let api_url = config.BASE_URL + "api/getUploadedFiles";
  return callPOST(api_url, param);
}

//POST - LOGIN USER
async function login(param) {
  let api_url = config.BASE_URL + "api/login";
  return fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      if (items.status === 200) {
        console.log(">> Service Login Data", items);
        localStorage.setItem("token", items.token);
        localStorage.setItem("application", items?.data?.defaultAppCode);
        localStorage.setItem("userData", JSON.stringify(items));
        // sessionStorage.setItem('token',items.token);
        return items;
      } else {
        return items;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

//POST - LOGOUT USER
async function logout(param) {
  let api_url = config.BASE_URL + "api/logout";
  return fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authentication: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      console.log(">> Service Logout", items);
      localStorage.setItem("token", "");
      localStorage.setItem("userData", "");
      localStorage.setItem("application", "");
      return items;
    })
    .catch((error) => {
      handleError(error);
    });
}

//appConfigFunc
async function appConfigFunc(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/appConfig";
  return callPOST(api_url, param);
}

//POST - REGISTER USER
async function registerUser(param) {
  let api_url = config.BASE_URL + "api/register";
  return callPOST(api_url, param);
}

//POST - Validate Token
async function validateToken(token) {
  let api_url = config.BASE_URL + "api/validate-token";
  return callPostResetPassword(api_url, {}, token);
}

//POST - Reset Password
async function resetPassword(param, token) {
  let api_url = config.BASE_URL + "api/reset-password";
  return callPostResetPassword(api_url, param, token);
}

//POST - USER PROFILE IMAGE UPLOAD
async function uploadImg(param) {
  let api_url = config.BASE_URL + "api/uploadImg";
  return callPOSTUpload(api_url, param);
}

//POST - userUpdate Commmon
async function userUpdate(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/userUpdate";
  return callPOST(api_url, param);
}

/* ---------------------------- Common --------------------------------*/

//POST - getMasterData Commmon
async function getMasterData(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getMasterData";
  return callPOST(api_url, param);
}

//POST - getBankMasterData Commmon
async function getBankMasterData(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getBankMaster";
  return callGET(api_url, param);
}

//GET - getConstantVariable Commmon
async function getConstantVariable(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getConstantVariable";
  return callGET(api_url, param);
}

//POST - getApplicationMaster Commmon
async function getApplicationMaster(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getApplicationMaster";
  return callPOST(api_url, param);
}

//POST - getCategory Commmon
async function getCategory(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getCategory";
  return callPOST(api_url, param);
}

//POST - getSubCategory Commmon
async function getSubCategory(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSubCategory";
  return callPOST(api_url, param);
}

//POST - getSubCategoryRoleId Commmon
async function getSubCategoryRoleId(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSubCategoryRoleId";
  return callPOST(api_url, param);
}

//POST - addUser Commmon
async function addUser(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addUser";
  return callPOST(api_url, param);
}

//POST - getUsersListData Commmon
async function getUsersListData(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getUserList";
  return callPOST(api_url, param);
}

/* ---------------------------- Category --------------------------------*/

//POST - addCategory Commmon
async function addCategory(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addCategory";
  return callPOST(api_url, param);
}

//POST - updateCategory Commmon
async function updateCategory(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/updateCategory";
  return callPOST(api_url, param);
}

//POST - deleteCategory Commmon
async function deleteCategory(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/deleteCategory";
  return callPOST(api_url, param);
}

/* ---------------------------- Workflow --------------------------------*/

//POST - getWorkflowInboxCards
async function getWorkflowInboxCards(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/workflowInboxCards";
  return callPOST(api_url, param);
}

//POST - getworkflowInboxList
async function getworkflowInboxList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/workflowInboxList";
  return callPOST(api_url, param);
}

//POST - workflowApproveReject
async function workflowApproveReject(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/actionOnWorkflowEvent";
  return callPOST(api_url, param);
}

//workflowActionAPI
async function workflowActionAPI(URL, param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + URL;
  return callPOST(api_url, param);
}

/* ---------------------------- Sourcing --------------------------------*/

//POST - getTechnicalUser
async function getTechnicalUser(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getTechnicalUser";
  return callPOST(api_url, param);
}
//POST - getCommercialUser
async function getCommercialUser(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getCommercialUser";
  return callPOST(api_url, param);
}
//POST - getRfqQuotation
async function getRfqQuotation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getRequestForQuotation";
  return callPOST(api_url, param);
}

//POST - getRfqQuotation
async function getEvaluatedRfq(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getEvaluatedRFQ";
  return callPOST(api_url, param);
}

//POST - getPurchaseRequisition
async function getPurchaseRequisition(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPurchaseRequisition";
  return callPOST(api_url, param);
}
//post addRfx
async function addRfx(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addRfx";
  return callPOST(api_url, param);
}

//POST - createRound (multi round RFQ)
async function createRound(param) {
  let api_url = config.BASE_URL + "api/createRound";
  return callPOST(api_url, param);
}
//POST - getRoundComparison (previous round quotation prices)
async function getRoundComparison(param) {
  let api_url = config.BASE_URL + "api/getRoundComparison";
  return callPOST(api_url, param);
}
//post addPR
async function addPR(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addPR";
  return callPOST(api_url, param);
}
//POST - getPRDetail
async function getPRDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPRDetail";
  return callPOST(api_url, param);
}
//POST - getRfxDocumentDetail
async function getRfxDocumentDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getRfxDocumentDetail";
  return callPOST(api_url, param);
}
//POST - rfxTechOpen
async function rfxTechOpen(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/rfxTechOpen";
  return callPOST(api_url, param);
}
//POST - rfxCommOpen
async function rfxCommOpen(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/rfxCommOpen";
  return callPOST(api_url, param);
}

// ------------------
//POST - generateQuery
async function generateQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/generateQuery";
  return callPOST(api_url, param);
}

// --------------------- Questionnaire APIs ---------------------

//POST - addQuestionnaire
async function addQuestionnaire(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addQuestionnaire";
  return callPOST(api_url, param);
}

//POST - updateQuestionnaire
async function updateQuestionnaire(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/updateQuestionnaire";
  return callPOST(api_url, param);
}

//POST - deleteQuestionnaire
async function deleteQuestionnaire(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/deleteQuestionnaire";
  // Ensure we use _id instead of documentNumber
  if (param && param.documentNumber && !param._id) {
    param = { ...param, _id: param.documentNumber };
  }
  return callPOST(api_url, param);
}

//----------------------

//POST - getPRLineItems
async function getPRLineItems(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPRLineItems";
  return callPOST(api_url, param);
}
//POST - rfxAcknowledgementOrRegret
async function rfxAcknowledgementOrRegret(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/rfxAcknowledgementOrRegret";
  return callPOST(api_url, param);
}
//POST - addQuotation
async function addQuotation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addQuotation";
  return callPOST(api_url, param);
}
//POST - getQuotation
async function getQuotation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getQuotation";
  return callPOST(api_url, param);
}
//POST - getQuotationDatail
async function getQuotationDatail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getQuotationDatail";
  return callPOST(api_url, param);
}
//POST - addRfxTechEvaluation
async function addRfxTechEvaluation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addRfxTechEvaluation";
  return callPOST(api_url, param);
}
//POST - addRfxCommEvaluation
async function addRfxCommEvaluation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addRfxCommEvaluation";
  return callPOST(api_url, param);
}

// PR category counts
async function getPRCategoryCounts(param){
  let api_url = config.BASE_URL + "api/getPurshaseRequisition/Category-count";
  return callPOST(api_url, param);
}

// PO category counts
async function getPOCategoryCounts(param){
  let api_url = config.BASE_URL + "api/getPurchaseOrders/Category-counts";
  return callPOST(api_url, param);
}

async function dashboardAlerts(){
  let api_url = config.BASE_URL + "api/dashboard/alerts"
  return callPOST(api_url)
}


/* ---------------------------- Supplier --------------------------------*/

//POST - getSupplierList
async function getSupplierList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSupplierList";
  return callPOST(api_url, param);
}

//POST - getVendorPerformance
async function getVendorPerformance(param) {
  let api_url = config.BASE_URL + "api/getVendorPerformance";
  return callPOST(api_url, param);
}
//POST - getSupplierPerformanceEvaluation
async function getSupplierPerformanceEvaluation(param) {
  let api_url = config.BASE_URL + "api/getSupplierPerformanceEvaluation";
  return callPOST(api_url, param);
}
//POST - getVendorPerformanceList
async function getVendorPerformanceList(param) {
  let api_url = config.BASE_URL + "api/getVendorPerformanceList";
  return callPOST(api_url, param);
}
//POST - getMultipleSupplierPerformanceEvaluation
async function getMultipleSupplierPerformanceEvaluation(param) {
  let api_url = config.BASE_URL + "api/getMultipleSupplierPerformanceEvaluation";
  return callPOST(api_url, param);
}
//POST - getSupplierPOPerformance
async function getSupplierPOPerformance(param) {
  let api_url = config.BASE_URL + "api/getSupplierPOPerformance";
  return callPOST(api_url, param);
}
 
//POST - getSupplierCategorySelection
async function getSupplierCategorySelection(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSupplierCategorySelection";
  return callPOST(api_url, param);
}
//POST - addSupplier
async function addSupplier(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addSupplier";
  return callPOST(api_url, param);
}
//POST - supplierAddAdvancePaymentRequest
async function supplierAddAdvancePaymentRequest(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/supplierAddAdvancePaymentRequest";
  return callPOST(api_url, param);
}
//POST - updateAdvancePaymentRequest
async function updateAdvancePaymentRequest(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/updateAdvancePaymentRequest";
  return callPOST(api_url, param);
}
//POST - send invitation
async function sendInvitation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/sendInvitation";
  return callPOST(api_url, param);
}
async function supplierBroadcast(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/supplierBroadcast";
  return callPOST(api_url, param);
}
async function supplierDeactivate(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/supplierDeactivate";
  return callPOST(api_url, param);
}
async function inviteSupplier(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/inviteSupplier";
  return callPOST(api_url, param);
}
//POST - sendPreQualificationInvitation
async function sendPreQualificationInvitation(param) {
  let api_url = config.BASE_URL + "api/sendPreQualificationInvitation";
  return callPOST(api_url, param);
}
//POST - submitPreQualification
async function submitPreQualification(param) {
  let api_url = config.BASE_URL + "api/submitPreQualification";
  return callPOST(api_url, param);
}
//POST - getPreQualificationList
async function getPreQualificationList(param) {
  let api_url = config.BASE_URL + "api/getPreQualificationList";
  return callPOST(api_url, param);
}

/* ---------------------------- PQ Vendor List (separate APIs) --------------------------------*/

//POST - getPQVendorList
async function getPQVendorList(param) {
  let api_url = config.BASE_URL + "api/getPQVendorList";
  return callPOST(api_url, param);
}

//POST - addPQVendor
async function addPQVendor(param) {
  let api_url = config.BASE_URL + "api/addPQVendor";
  return callPOST(api_url, param);
}

//POST - getPQVendorDetail
async function getPQVendorDetail(param) {
  let api_url = config.BASE_URL + "api/getPQVendorDetail";
  return callPOST(api_url, param);
}

//POST - updatePQVendor
async function updatePQVendor(param) {
  let api_url = config.BASE_URL + "api/updatePQVendor";
  return callPOST(api_url, param);
}

//POST - getPQSubmissionDetails
async function getPQSubmissionDetails(param) {
  let api_url = config.BASE_URL + "api/getPQSubmissionDetails";
  return callPOST(api_url, param);
}

//POST - getPQWorkflowDetail
async function getPQWorkflowDetail(param) {
  let api_url = config.BASE_URL + "api/getPQWorkflowDetail";
  return callPOST(api_url, param);
}

//POST - getUserDetail
async function getUserDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getUserDetail";
  return callPOST(api_url, param);
}
//POST - getSupplierDatail
async function getSupplierDatail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSupplierDatail";
  return callPOST(api_url, param);
}
//POST - getSupplierBank
async function getSupplierBank(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSupplierBank";
  return callPOST(api_url, param);
}

/* ---------------------------- Company Creation (companyDoc) --------------------------------*/

//POST - addCompany
async function addCompany(param) {
  let api_url = config.BASE_URL + "api/addCompany";
  return callPOST(api_url, param);
}

//POST - updateCompany
async function updateCompany(param) {
  let api_url = config.BASE_URL + "api/updateCompany";
  return callPOST(api_url, param);
}

//POST - getCompanyList
async function getCompanyList(param) {
  let api_url = config.BASE_URL + "api/getCompanyList";
  return callPOST(api_url, param);
}

//POST - getCompanyDetail
async function getCompanyDetail(param) {
  let api_url = config.BASE_URL + "api/getCompanyDetail";
  return callPOST(api_url, param);
}

//POST - deleteCompany
async function deleteCompany(param) {
  let api_url = config.BASE_URL + "api/deleteCompany";
  return callPOST(api_url, param);
}

/* ---------------------------- Budget Creation (budgetCreationDoc) --------------------------------*/

//POST - addBudget
async function addBudget(param) {
  let api_url = config.BASE_URL + "api/addBudget";
  return callPOST(api_url, param);
}

//POST - updateBudget
async function updateBudget(param) {
  let api_url = config.BASE_URL + "api/updateBudget";
  return callPOST(api_url, param);
}

//POST - getBudgetList
async function getBudgetList(param) {
  let api_url = config.BASE_URL + "api/getBudgetList";
  return callPOST(api_url, param);
}

//POST - getBudgetDetail
async function getBudgetDetail(param) {
  let api_url = config.BASE_URL + "api/getBudgetDetail";
  return callPOST(api_url, param);
}

//POST - deleteBudget
async function deleteBudget(param) {
  let api_url = config.BASE_URL + "api/deleteBudget";
  return callPOST(api_url, param);
}

// ------ SELF SUPPLIER REG API WITHOUT AUTH-------
async function addSelfSupplier(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addSelfSupplier";
  return callPOST(api_url, param);
}
async function getMasterDataSelf(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getMasterDataSelf";
  return callPOST(api_url, param);
}

/* ---------------------------- PO COLLABRATION --------------------------------*/
//POST - getPurchaseOrder
async function getPurchaseOrder(param) {
  // This method calling from Redux
  // let api_url= config.BASE_URL + "api/getPurchaseOrder";
  let api_url = config.BASE_URL + "api/generateQuery";
  return callPOST(api_url, param);
}
//POST - addPO
async function addPO(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addPO";
  return callPOST(api_url, param);
}
//POST - getPurchaseOrderDetail
async function getPurchaseOrderDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPurchaseOrderDetail";
  return callPOST(api_url, param);
}

/* -------------- ASN --------------*/
//POST - getASN
async function getASN(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getAsn";
  return callPOST(api_url, param);
}

//POST - addASN
async function addASN(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addASN";
  return callPOST(api_url, param);
}
//POST - getAsnDetail
async function getAsnDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getAsnDetail";
  return callPOST(api_url, param);
}
//POST - getPOAsn
async function getPOAsn(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPOAsn";
  return callPOST(api_url, param);
}

/* -------------- GRN --------------*/
//POST - addGRN
async function addGRN(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addGRN";
  return callPOST(api_url, param);
}

//POST - getGrnDatail
async function getGrnDatail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getGrnDatail";
  return callPOST(api_url, param);
}

//POST - AcknowledgePO
async function AcknowledgePO(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/acknowledgePO";
  return callPOST(api_url, param);
}
//POST - getPOGrn
async function getPOGrn(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPOGrn";
  return callPOST(api_url, param);
}

/* -------------- PO Invoice --------------*/
//POST - getPOInvoice
async function getPOInvoice(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPOInvoice";
  return callPOST(api_url, param);
}
//POST - createInvoice
async function createInvoice(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/createInvoice";
  return callPOST(api_url, param);
}
//POST - CreateInvoiceSES
async function CreateInvoiceSES(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/createServiceInvoice";
  return callPOST(api_url, param);
}
//POST - addInvoice
async function addInvoice(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addInvoice";
  return callPOST(api_url, param);
}
//POST - getInvoiceDetail
async function getInvoiceDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getInvoiceDetail";
  return callPOST(api_url, param);
}
//POST - getInvoiceList
async function getInvoiceList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getInvoiceList";
  return callPOST(api_url, param);
}
//POST - uploadOCRFile
async function uploadOCRFile(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/uploadOCRFileV2";
  return callPOSTUpload(api_url, param);
}
//POST - uploadInvoiceOCR
async function uploadInvoiceOCR(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/uploadOCRFileV5";
  return callPOSTUpload(api_url, param);
}

//POST - updatePOFields (generic PO field update)
async function updatePOFields(param) {
  let api_url = config.BASE_URL + "api/updatePOFields";
  return callPOST(api_url, param);
}
//POST - addInvoiceFromOCR (create invoice from OCR header details)
async function addInvoiceFromOCR(param) {
  let api_url = config.BASE_URL + "api/addInvoiceFromOCR";
  return callPOST(api_url, param);
}

/* -------------- Service Entrysheet --------------*/
//POST - addEntrysheet
async function addEntrysheet(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addEntrysheet";
  return callPOST(api_url, param);
}
//POST - getSesDatail
async function getSesDatail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSesDatail";
  return callPOST(api_url, param);
}
//POST - getSesList
async function getSesList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSesList";
  return callPOST(api_url, param);
}
//POST - getPOSes
async function getPOSes(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPOSes";
  return callPOST(api_url, param);
}
//POST - createSES
async function createSES(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/createSES";
  return callPOST(api_url, param);
}

//POST - cancelDocument
async function cancelDocument(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/cancelDocument";
  return callPOST(api_url, param);
}
//POST - getGoodsReceivedNote
async function getGoodsReceivedNote(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getGoodsReceivedNote";
  return callPOST(api_url, param);
}

/* ---------------------------- Gatepass --------------------------------*/
//POST - getGatepassList
async function getGatepassList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getGatepassList";
  return callPOST(api_url, param);
}

//POST - getGatepass Create
async function getGatepassCreate(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addGatepass";
  return callPOST(api_url, param);
}

//POST - getAsnNumForGatepass Create
async function getAsnNumForGatepass(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getAsnNumForGatepass";
  return callPOST(api_url, param);
}

/* ---------------------------- SingleSourcing --------------------------------*/

//POST - addSingleSourceRequest Commmon
async function addSingleSourceRequest(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/addSingleSourceRequest";
  return callPOST(api_url, param);
}

//POST - getSingleSourcingList Commmon
async function getSingleSourcingList(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getSingleSourceRequest";
  return callPOST(api_url, param);
}

/* ---------------------------- Report --------------------------------*/
//POST - generateReportQuery Commmon
async function generateReportQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/generateReportQuery";
  return callPOST(api_url, param);
}

//getPlant
async function getPlant(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getPlant";
  return callPOST(api_url, param);
}

//getVendorId
async function getVendorId(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getVendorId";
  return callPOST(api_url, param);
}

//Check Validation
async function checkValidation(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/check-validation";
  return callPOST(api_url, param);
}

//Check forgotPassword
async function forgotPassword(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/forgot-password";
  return callPOST(api_url, param);
}
async function verifyOtp(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/verify-otp";
  return callPOST(api_url, param);
}

//Change Password
async function changePassword(param) {
  let api_url = config.BASE_URL + "api/change-password";
  return callPOST(api_url, param);
}

//Generate Chart Query
async function generateChartQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/generateChartQuery";
  return callPOST(api_url, param);
}

/* ---------------------------- Dashboard --------------------------------*/

//totalUserCount
async function totalUserCount(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/totalUserCount";
  return callPOST(api_url, param);
}
//supplierCount
async function supplierCount(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/supplierCount";
  return callPOST(api_url, param);
}
//poCount
async function poCount(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/poCount";
  return callPOST(api_url, param);
}
//prCount
async function prCount(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/prCount";
  return callPOST(api_url, param);
}

async function prAgeing(param){
  let api_url = config.BASE_URL + "api/getPurchaseRequisitionAgeing"
  return callPOST(api_url, param)
}

//dashboard - supplier // "Yearly", "Monthly", "Custom"
async function dashboard(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/dashboard";
  return callPOST(api_url, param);
}

async function POExtraction(param) {
  let api_url = config.BASE_URL + "common/api/POExtraction";
  return callPOST(api_url, param);
}
async function getCustomerDetail(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer-v1/api/getCustomerDetail";
  return callPOST(api_url, param);
}

async function addAuction(param) {
  let api_url = config.BASE_URL + "customer/api/addAuction";
  return callPOST(api_url, param);
}
async function getAuctionDetail(param) {
  let api_url = config.BASE_URL + "customer/api/getAuctionDetail";
  return callPOST(api_url, param);
}
async function ackOrRegretAuction(param) {
  let api_url = config.BASE_URL + "customer/api/ackOrRegretAuction";
  return callPOST(api_url, param);
}
async function updateAuctionDetail(param) {
  let api_url = config.BASE_URL + "customer/api/updateAuctionDetail";
  return callPOST(api_url, param);
}
async function deleteAuctionDetail(param) {
  let api_url = config.BASE_URL + "customer/api/deleteAuctionDetail";
  return callPOST(api_url, param);
}

async function auctionSendInvitation(param) {
  let api_url = config.BASE_URL + "customer/api/auction/sendInvitation";
  return callPOST(api_url, param);
}
async function auctionSendModification(param) {
  let api_url = config.BASE_URL + "customer/api/auction/sendModification";
  return callPOST(api_url, param);
}
async function auctionPlaceBid(param) {
  let api_url = config.BASE_URL + "customer/api/auction/placeBid";
  return callPOST(api_url, param);
}
async function auctionGetBids(param) {
  let api_url = config.BASE_URL + "customer/api/auction/getAuctionBids";
  return callPOST(api_url, param);
}
async function auctionGetLeaderboard(param) {
  let api_url = config.BASE_URL + "customer/api/auction/getBidLeaderboard";
  return callPOST(api_url, param);
}
async function auctionClose(param) {
  let api_url = config.BASE_URL + "customer/api/auction/closeAuction";
  return callPOST(api_url, param);
}
async function auctionGetItemLeaderboard(param) {
  let api_url = config.BASE_URL + "customer/api/auction/getItemLeaderboard";
  return callPOST(api_url, param);
}
async function auctionGetBidHistory(param) {
  let api_url = config.BASE_URL + "customer/api/auction/getBidHistory";
  return callPOST(api_url, param);
}
 
async function auctionAcknowledgeTerms(param) {
  let api_url = config.BASE_URL + "customer/api/auction/acknowledgeTerms";
  return callPOST(api_url, param);
}
async function generateCustomerQuery(param) {
  let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
  return callPOST(api_url, param);
}
async function updateGRN(param) {
  let api_url = config.BASE_URL + "api/updateGRN";
  return callPOST(api_url, param);
}
async function cancelGRN(param) {
  let api_url = config.BASE_URL + "api/cancelGRN";
  return callPOST(api_url, param);
}
async function cancelQualityCheck(param) {
  let api_url = config.BASE_URL + "api/cancelQualityCheck";
  return callPOST(api_url, param);
}
async function updateQualityCheck(param) {
  let api_url = config.BASE_URL + "api/updateQualityCheck";
  return callPOST(api_url, param);
}

// Sample Management APIs
async function addSampleRequest(param) {
  let api_url = config.BASE_URL + "api/addSampleRequest";
  return callPOST(api_url, param);
}
async function getSampleRequestList(param) {
  let api_url = config.BASE_URL + "api/getSampleRequestList";
  return callPOST(api_url, param);
}
async function getSampleRequestDetail(param) {
  let api_url = config.BASE_URL + "api/getSampleRequestDetail";
  return callPOST(api_url, param);
}
async function updateSampleArtwork(param) {
  let api_url = config.BASE_URL + "api/updateSampleArtwork";
  return callPOST(api_url, param);
}
async function updateSampleApproval(param) {
  let api_url = config.BASE_URL + "api/updateSampleApproval";
  return callPOST(api_url, param);
}

async function addQualityCheck(param) {
  let api_url = config.BASE_URL + "api/addQualityCheck";
  return callPOST(api_url, param);
}
async function getQualityCheckList(param) {
  let api_url = config.BASE_URL + "api/getQualityCheckList";
  return callPOST(api_url, param);
}
async function getQualityCheckDetail(param) {
  let api_url = config.BASE_URL + "api/getQualityCheckDetail";
  return callPOST(api_url, param);
}
async function getGRNDetailsForQualityCheck(param) {
  let api_url = config.BASE_URL + "api/getGRNDetailsForQualityCheck";
  return callPOST(api_url, param);
}

async function updateGRNDocs(param) {
  let api_url = config.BASE_URL + "api/updateGRNDocs";
  return callPOST(api_url, param);
}
async function addMaterialBarcodeItem(param) {
  let api_url = config.BASE_URL + "api/addMaterialBarcodeItem";
  return callPOST(api_url, param);
}
async function deleteFile(param) {
  let api_url = config.BASE_URL + "api/deleteFile";
  return callPOST(api_url, param);
}

//POST - updateRfx (extend closing time)
async function updateRfx(param) {
  let api_url = config.BASE_URL + "api/updateRfx";
  return callPOST(api_url, param);
}

//POST - sendRfqReminder
async function sendRfqReminder(param) {
  let api_url = config.BASE_URL + "api/sendRfqReminder";
  return callPOST(api_url, param);
}

  //POST - updatePR
async function updatePR(param) {
  let api_url = config.BASE_URL + "api/updatePR";
  return callPOST(api_url, param);
}

//POST - updatePRDetails
async function updatePRDetails(param) {
  let api_url = config.BASE_URL + "api/updatePRDetails";
  return callPOST(api_url, param);
}

//POST - sendRFIRaisedEmail - when PROC-MNGR submits a Request Info
async function sendRFIRaisedEmail(param) {
  let api_url = config.BASE_URL + "api/sendRFIRaisedEmail";
  return callPOST(api_url, param);
}

//POST - sendRFIResponseEmail - when admin/other replies to a Request Info
async function sendRFIResponseEmail(param) {
  let api_url = config.BASE_URL + "api/sendRFIResponseEmail";
  return callPOST(api_url, param);
}

// --------------------------- Vendor Self Registration Draft Functionlity ----------------------
 
// POST - get draft initial data
async function getDraftInitial(userId, draftType) {
  let api_url = config.BASE_URL + "draft/api/initial";
  let param = { userId, draftType: draftType };
  return callPOST(api_url, param);
}
 

// Get a specific draft by document number
async function getDraftById(draftNumber, draftType, userId) {
  try {
    let api_url = config.BASE_URL + "draft/api/getDraftData/" + draftNumber;
    // const response = await axios.get(`/api/drafts/${draftNumber}`);
    let param = { draftType, userId };
    return callPOST(api_url, param);
  } catch (error) {
    console.error('getDraftById error', error);
    throw error;
  }
};
 
// POST - create new draft
async function createDraft(userId, draftType) {
  let api_url = config.BASE_URL + "draft/api/create";
  let param = { userId, draftType };
  return callPOST(api_url, param);
}
 
// PATCH - update draft
async function updateDraft(documentNumber, userId, draftType, changedData) {
  let api_url = config.BASE_URL + "draft/api/update";
  let param = {
    documentNumber,
    userId,
    draftType,
    ...changedData,
  };
  return callPATCH(api_url, param);
}

async function renameDraft(draftNumber, userId, draftType, newName) {
  try {
    let api_url = config.BASE_URL + "draft/api/rename";
    let param = {
      documentNumber: draftNumber,
      userId,
      draftType,
      newName,
    };
    return callPATCH(api_url, param);
  }
  catch (error) {
    console.error('renameDraft error', error);
    throw error;
  }
}

async function getDraftCount(userId, draftType) {
  try {
    let api_url = config.BASE_URL + "draft/api/getDraftCount";
    let payload = { userId, draftType };
    return callPOST(api_url, payload);
  } catch (error) {
    console.error('getDraftCount error', error);
    throw error;
  }
}

// Delete a draft
async function deleteDraft(draftNumber, draftType, userId){
  try {
    let api_url = config.BASE_URL + "draft/api/delete";
    // const response = await axios.delete(`/api/drafts/${draftNumber}`);
    let params = {
      documentNumber: draftNumber,
      draftType,
      userId,
    };
    return callPOST(api_url, params);

  } catch (error) {
    console.error('deleteDraft error', error);
    throw error;
  }
};

// ============================================================================================

const func = {
  addAuction,
  ackOrRegretAuction,
  getAuctionDetail,
  updateAuctionDetail,
  deleteAuctionDetail,
    auctionSendInvitation,
  auctionSendModification,
  auctionPlaceBid,
  auctionGetBids,
  auctionGetLeaderboard,
  auctionClose,
  auctionGetItemLeaderboard,
  auctionGetBidHistory,
  auctionAcknowledgeTerms,
  appConfigFunc,
  uploadFiles,
  getUploadedFiles,
  getMasterData,
  getBankMasterData,
  getConstantVariable,
  getApplicationMaster,
  getCategory,
  getSubCategory,
  getSubCategoryRoleId,
  addUser,
  getUsersListData,

  addCategory,
  updateCategory,
  deleteCategory,

  login,
  logout,
  registerUser,
  validateToken,
  resetPassword,

  userUpdate,
  uploadImg,
  handleResponseError,
  handleError,
  callGET,
  callPOST,
  callPOSTUpload,
  callPostResetPassword,

  getConfig,
  getMenuOnUserRole,
  getLoginUserData,

  getWorkflowInboxCards,
  getworkflowInboxList,
  workflowApproveReject,
  workflowActionAPI,

  getTechnicalUser,
  getCommercialUser,
  getRfqQuotation,
  getEvaluatedRfq,
  getPurchaseRequisition,
  getQuotation,
  getQuotationDatail,
  addRfx,
  addPR,
  getPRDetail,
  getRfxDocumentDetail,
  rfxTechOpen,
  rfxCommOpen,

  getPRCategoryCounts,
  getPOCategoryCounts,
  dashboardAlerts,

  getPRLineItems,
  rfxAcknowledgementOrRegret,
  addQuotation,
  addRfxTechEvaluation,
  addRfxCommEvaluation,

  generateQuery,
  generateReportQuery,
  getPlant,
  getVendorId,
  addQuestionnaire,
  updateQuestionnaire,
  deleteQuestionnaire,

  addSelfSupplier,
  getMasterDataSelf,

  getSupplierList,
  getSupplierCategorySelection,
  addSupplier,
  supplierAddAdvancePaymentRequest,
  updateAdvancePaymentRequest,
  getUserDetail,
  getSupplierDatail,
  getSupplierBank,
  addCompany,
  updateCompany,
  getCompanyList,
  getCompanyDetail,
  deleteCompany,
  addBudget,
  updateBudget,
  getBudgetList,
  getBudgetDetail,
  deleteBudget,
  inviteSupplier,
  sendPreQualificationInvitation,
  submitPreQualification,
  getPreQualificationList,
  getPQVendorList,
  addPQVendor,
  getPQVendorDetail,
  updatePQVendor,
  getPQSubmissionDetails,
  getPQWorkflowDetail,
  sendInvitation,
  supplierBroadcast,
  supplierDeactivate,

  getPurchaseOrder,
  addPO,
  getGoodsReceivedNote,

  getASN,
  addASN,
  getAsnDetail,
  getPOAsn,

  addGRN,
  getGrnDatail,
  AcknowledgePO,
  getPOGrn,

  getPOInvoice,
  createInvoice,
  CreateInvoiceSES,
  addInvoice,
  getInvoiceDetail,
  getInvoiceList,
  uploadOCRFile,
  uploadInvoiceOCR,

  addEntrysheet,
  getSesDatail,
  getSesList,
  getPOSes,
  createSES,

  cancelDocument,
  getPurchaseOrderDetail,
  updatePOFields,
  addInvoiceFromOCR,

  getGatepassList,
  getGatepassCreate,
  getAsnNumForGatepass,

  addSingleSourceRequest,
  getSingleSourcingList,

  checkValidation,
  forgotPassword,
  verifyOtp,
  changePassword,
  generateChartQuery,

  totalUserCount,
  supplierCount,
  poCount,
  prCount,
  prAgeing,
  dashboard,

  POExtraction,
  getCustomerDetail,
  generateCustomerQuery,
  updateGRN,
  cancelGRN,
  cancelQualityCheck,
  updateQualityCheck,
  updateGRNDocs,
  addMaterialBarcodeItem,
  deleteFile,

  getDraftInitial,
  createDraft,
  updateDraft,
  getDraftById,
  renameDraft,
  getDraftCount,
  deleteDraft,
  updateRfx,
  sendRfqReminder,
  updatePR,
  updatePRDetails,
  sendRFIRaisedEmail,
  sendRFIResponseEmail,
  getVendorPerformance,
  getSupplierPerformanceEvaluation,
  getVendorPerformanceList,
  getMultipleSupplierPerformanceEvaluation,
  getSupplierPOPerformance,
addSampleRequest,
  getSampleRequestList,
  getSampleRequestDetail,
  updateSampleArtwork,
  updateSampleApproval,
  addQualityCheck,
  getQualityCheckList,
  getQualityCheckDetail,
  getGRNDetailsForQualityCheck,
  createRound,
  getRoundComparison

};

export default func;
